import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['type', 'description', 'kindergartenSelect', 'kindergartenInput']

    connect() {
        this.update()
    }

    update() {
        const selectedType = this.typeTarget.value
        this.descriptionTargets.forEach((el) => {
            el.classList.toggle('d-none', el.dataset.type !== selectedType)
        })
        this._updateKindergartens(selectedType)
    }

    _updateKindergartens(selectedType) {
        if (!this.hasKindergartenSelectTarget) return

        const isKita = selectedType === 'kita'
        this.kindergartenSelectTarget.classList.toggle('d-none', !isKita)

        if (this.hasKindergartenInputTarget) {
            this.kindergartenInputTarget.required = isKita
        }
    }
}
